import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { updateCategoryAction } from "../../../redux/coupon/updateCategoryRTK";
import { DevTool } from "@hookform/devtools";
import { useState } from "react";
import { Alert } from "@mui/material";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";
import axios from "../../../config/authaxios";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
};

const updateCategorySchema = yup
  .object({
    categoryname: yup.string().required(),
    cashback_percentage: yup.number().required().typeError('Please fill the percentage'),
    position: yup.number().when("popular_category", {
      is: true,
      then: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired(),
      otherwise: yup
        .number()
        .required("please fill the position")
        .typeError("Please fill the position"),
    }),

  })
  .required();

export default function UpdateCategory({
  updateCategory,
  setUpdateCategory,
  propsData,
}) {
  // state---->
  console.log("propsData-->",propsData)
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(updateCategorySchema),
    defaultValues: {
      popular_category: propsData?.isPublisherCategory
        ? !!propsData?.is_popular_category
        : !!propsData?.popular_category,
    },
  });
  const isPopularCategory = watch("popular_category");
  const updateCategorySelector = useSelector((state) => state.updateCategory);
  const { data, status, message, error } = updateCategorySelector;
  const dispatchRTK = useDispatch();
  const [snackbarState, setSnackbarState] = useState(false)

  const [imageUploaded,setImageUploaded]=useState(propsData.image)



  // function -->
  const handleClose = () => {
    setUpdateCategory(false);
  };
  const updateCategoryFunc = (data) => {

    dispatchRTK(
      updateCategoryAction(
        propsData?.isPublisherCategory
          ? {
              isPublisherCategory: true,
              category_id: propsData?.category_id,
              name: data?.categoryname,
              cashback_percentage: data?.cashback_percentage,
              position: data?.position,
              image: imageUploaded,
              is_popular_category: !!data?.popular_category,
            }
          : {
              catId: propsData?.catId,
              name: data?.categoryname,
              cashback_percentage: data?.cashback_percentage,
              position: data?.position,
              image: imageUploaded,
              popular_category: !!data?.popular_category,
            }
      )
    );
    if (data?.status_code == 200) {
      setUpdateCategory(false);
    }
    setSnackbarState(true)
  };
  const snackBarClose = () => {
    setSnackbarState(false)
    setUpdateCategory(false)
  }
  
  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
    // //console.log(img, file);
    width = this.width;
    height = this.height;
    
    axios.post(`/admin/upload-image`, Dataform).then((res) => {
    //console.log(">>Image_url>>", res.data.Image.url);
    
    // setCoupons({ ...coupons, image: res.data.Image.url });
    setImageUploaded(res.data.Image.url)
    // setEditPropsData({ ...editPropsData, 'image': res.data.Image.url })
    // setImage(res.data.Image.url);
    //console.log("coupons-->",coupons)
    });
    alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
    
    };
    img.onerror = function () {
    alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
    };



  return (
    <>
      <Modal
        open={updateCategory}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box style={style}>
          <Stack
            direction="row"
            sx={{ diplay: "flexl", justifyContent: "space-between" }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Update Category
            </Typography>
            {console.log("propsData-->", propsData)}
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <form onSubmit={handleSubmit(updateCategoryFunc)}>
            <Stack spacing={2}>
              <TextField
                label="Category Name"
                variant="outlined"
                defaultValue={propsData?.name}
                fullWidth
                {...register("categoryname")}
                error={errors?.categoryname?.message}
                helperText={errors?.categoryname?.message}
              />
              <TextField
                label="Cashback Percentage"
                variant="outlined"
                defaultValue={propsData?.cashback_percentage}
                fullWidth
                {...register("cashback_percentage")}
                error={errors?.cashback_percentage?.message}
                helperText={errors?.cashback_percentage?.message}
              />
              {!isPopularCategory && (
                <TextField
                  label="Position"
                  variant="outlined"
                  defaultValue={propsData?.position}
                  fullWidth
                  {...register("position")}
                  error={errors?.position?.message}
                  helperText={errors?.position?.message}
                />
              )}
            </Stack>

            {!isPopularCategory && (
              <>
                <label htmlFor="contained-button-file">
                    <input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      onChange={handlefileInput}
                      style={{ display: "none" }}
                    />
                    <Button
                      variant="contained"
                      component="span"
                      // endIcon={<DriveFolderUploadIcon />}
                      color="info"
                    >
                      Upload Image
                    </Button>
                  </label>

                   {imageUploaded && <img src={imageUploaded} width="50px"/>}
              </>
            )}
            <Controller
              name="popular_category"
              control={control}
              defaultValue={
                propsData?.isPublisherCategory
                  ? !!propsData?.is_popular_category
                  : !!propsData?.popular_category
              }
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  }
                  label="Mark as Popular Category"
                />
              )}
            />
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Button variant="contained" color="primary" type="submit">
                Update
              </Button>
              <Button variant="contained" color="error" onClick={handleClose}>
                close
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>


      {/* snackbar */}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState} autoHideDuration={1000} onClose={snackBarClose}>
        <Alert onClose={snackBarClose} severity={status == 200 ? "success" : "error"} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
